import React from 'react';
import produce from 'immer';

import { Text, WrapperFlex, Alerts, Button } from '@unimed-fesp/components';

import { MdErrorOutline } from 'react-icons/md';
import { FaRegCheckCircle } from 'react-icons/fa';
import theme from '../../../styles/theme';

import { ReSendContainer, UnlockIConContainer, SpanTextoAlert } from './styles';

import InputForm from '../../atoms/InputForm';

import LabelContainer from '../../molecules/LabelContainer';

const DadosAcesso = ({
  dadosAcessoParams,
  setDadosAcessoParams,
  usuarioDadosAcesso,
  handleAcaoUsuarioById,
}) => {
  function handleInput(e, status) {
    const newDadosAcessoParams = produce(dadosAcessoParams, (draft) => {
      if (draft[status] !== e.target.value) draft[status] = e.target.value;
    });

    setDadosAcessoParams(newDadosAcessoParams);
  }

  return (
    <WrapperFlex column justifyCenter alignCenter>
      <WrapperFlex column justifyCenter alignStart>
        <Text
          font="bold 16px/14px Calibri"
          color={theme.greenDefault}
          text="Acesso"
          paddingBottom={20}
        />
        <LabelContainer text="Nome do usuário" marginBottom="30">
          <InputForm
            handleChange={(e) => handleInput(e, 'nome')}
            marginTop="9"
            width="633"
            height="40"
            placeholder="Informe o nome completo do usuário"
            name="nome"
            value={dadosAcessoParams.nome}
            disabled
          />
        </LabelContainer>
        <LabelContainer text="E-mail do usuário" marginBottom="30">
          <InputForm
            handleChange={(e) => handleInput(e, 'email')}
            marginTop="9"
            width="458"
            height="40"
            placeholder="Informe o e-mail do usuário"
            name="email"
            value={dadosAcessoParams.email}
            disabled={dadosAcessoParams.tipoStatus === 'Inativo'}
          />
        </LabelContainer>
        <AlertUnlock
          type={dadosAcessoParams.tipoStatus}
          email={usuarioDadosAcesso.email}
          idUsuario={dadosAcessoParams.idUsuario}
          handleAcaoUsuarioById={handleAcaoUsuarioById}
        />
        {dadosAcessoParams.tipoStatus === 'Ativo' ? (
          <ReSendContainer>
            <Text text="Usuário não recebeu? " />
            <Text
              style={{ cursor: 'pointer' }}
              color={theme.greenDefault}
              text="Reenviar a liberação"
              onClick={() =>
                handleAcaoUsuarioById(
                  dadosAcessoParams.idUsuario,
                  'PendenteLiberacao'
                )
              }
            />
          </ReSendContainer>
        ) : (
          ''
        )}
      </WrapperFlex>
    </WrapperFlex>
  );
};

const AlertUnlock = ({ type, email, idUsuario, handleAcaoUsuarioById }) => {
  const ActionPorStatus = {
    Ativo: {
      Icon: <FaRegCheckCircle color={theme.greenDefault} size="20px" />,
      Text: 'Liberação enviada',
      SubText: 'Solicitação de finalização de cadastro foi enviada para',
      Display: '',
      DisplayButton: 'none',
      tipo: 'success',
    },
    PendenteLiberacao: {
      Icon: <MdErrorOutline color={theme.yellowDefault} size="20px" />,
      Text: 'Liberação ainda não enviada',
      SubText: 'Deseja enviar a liberação para',
      Display: '',
      DisplayButton: '',
      tipo: 'warning',
    },
    Inativo: {
      Icon: null,
      Text: null,
      SubText: null,
      Display: 'none',
      DisplayButton: '',
      tipo: 'warning',
    },
  };
  return (
    <Alerts
      display={ActionPorStatus[type].Display}
      width={650}
      type={ActionPorStatus[type].tipo}
      hideIcon
    >
      <WrapperFlex justifySpaceBetween alignCenter>
        <SpanTextoAlert>
          {ActionPorStatus[type].Icon} {ActionPorStatus[type].Text}
          <br />
          <p>
            {`${ActionPorStatus[type].SubText} `}
            <wbr />
            <b>{email}</b>
            {type !== 'Ativo' ? '?' : ''}
          </p>
        </SpanTextoAlert>
        {type === 'PendenteLiberacao' ? (
          <Button
            tipo="secondary"
            justifySpaceBetween
            alignCenter
            width={155}
            paddingTop={10}
            paddingRight={10}
            paddingBottom={10}
            paddingLeft={10}
            padding={10}
            font="600 14px unimed_slabregular !important"
            border={
              type === 'PendenteLiberacao'
                ? theme.yellowDefault
                : theme.greenDefault
            }
            display={type === 'PendenteLiberacao' ? 'flex' : 'none'}
            type="button"
            marginTop={18}
            color={
              type === 'PendenteLiberacao'
                ? theme.yellowDefault
                : theme.geenDefault
            }
            background={theme.white}
            onClick={() => handleAcaoUsuarioById(idUsuario, type)}
          >
            <UnlockIConContainer size="20" type={type} />
            liberar acesso
          </Button>
        ) : null}
      </WrapperFlex>
    </Alerts>
  );
};

export default DadosAcesso;
